module.exports = __webpack_public_path__ + "img/cidade-base.a4c42f24.jpg";